import { useNavigate } from "react-router-dom";

import type { StaffMyPageUserInfo } from "../../types";

interface Props {
  user: StaffMyPageUserInfo | undefined;
  isDark?: boolean; // 是否在深色/渐变背景中使用
}

export function UserDetail({ user, isDark }: Props) {
  const navigate = useNavigate();

  const textColor = isDark ? "text-white" : "text-gray-900";
  const subTextColor = isDark ? "text-white/70" : "text-gray-500";
  const phoneStyle = isDark
    ? { borderColor: "rgba(255,255,255,0.4)", color: "#fff" }
    : { borderColor: "#FF6B35", color: "#FF6B35" };
  const btnBg = isDark ? "bg-white/20" : "";
  const btnText = isDark ? "text-white" : "";

  return (
    <div className="flex items-center gap-4">
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src={user?.thumb || ""}
        alt=""
        className="w-[56px] h-[56px] rounded-full object-cover"
        style={{ border: isDark ? "2px solid rgba(255,255,255,0.3)" : `2px solid #FF6B35` }}
      />
      <div className="flex-1 min-w-0">
        <div className={`text-base font-bold ${textColor} truncate`}>{user?.name || "未设置"}</div>
        {user?.phone && (
          <div className="flex items-center gap-1.5 mt-1.5 w-fit px-2.5 py-1 rounded-full text-xs font-medium" style={phoneStyle}>
            <i className="ri-phone-line text-sm" />
            <span>{user.phone}</span>
          </div>
        )}
      </div>
      <button
        onClick={() => navigate("/workspace/profile/edit")}
        className={`px-4 py-2 rounded-full text-xs font-semibold active:scale-[0.98] transition-all ${isDark ? "bg-white/20 text-white" : ""}`}
        style={!isDark ? { background: BRAND_GRADIENT, color: "#fff" } : undefined}
      >
        个人资料
      </button>
    </div>
  );
}

const BRAND_GRADIENT = "linear-gradient(135deg, #FF6B35, #FF9A5C)";
